import { useContext } from 'react';
import { LocaleContext } from '../components/locale-context-provider';
import { ILocaleContextValue } from '../components/locale-context-provider/LocaleContextProvider';

const useLocaleContext = () => {
  return useContext(LocaleContext) as ILocaleContextValue;
};

export default useLocaleContext;
